import { fmtDate } from "@/lib/dateFormat";
import { useState } from "react";
import { Search, Download, Trash2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { toast } from "sonner";

export default function Gdpr() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const search = async (e) => {
    e?.preventDefault();
    if (!q.trim()) return;
    setLoading(true);
    try { const r = await api(`/customers/search?q=${encodeURIComponent(q.trim())}`); setResults(r.results || []); }
    catch (e2) { toast.error(e2.message); } finally { setLoading(false); }
  };

  const exportData = async (cid, name) => {
    try {
      const data = await api(`/gdpr/export/customer/${cid}`);
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = `gdpr-export-${name || cid}.json`; a.click(); URL.revokeObjectURL(url);
      toast.success("Data exported");
    } catch (e) { toast.error(e.message); }
  };
  const deleteData = async (cid) => {
    if (!window.confirm("Delete this customer's personal data? Financial records are retained (anonymised) for 6 years.")) return;
    try { const r = await api(`/gdpr/customer/${cid}`, { method: "DELETE" }); toast.success(`Redacted. Purge scheduled ${fmtDate(r.purge_at)}`); setResults(results.filter((c) => c.id !== cid)); }
    catch (e) { toast.error(e.message); }
  };

  return (
    <div className="mx-auto max-w-2xl">
      <PageHeader title="Customer Data (GDPR)" subtitle="Export or delete a customer's personal data on request" />
      <form onSubmit={search} className="mb-4 flex gap-2">
        <div className="relative flex-1"><Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, phone, email or VRM…" data-testid="gdpr-search-input" className="w-full rounded-lg border border-input bg-card py-2.5 pl-10 pr-3 text-sm outline-none focus:border-brand" /></div>
        <button type="submit" disabled={loading} data-testid="gdpr-search-btn" className="rounded-lg bg-brand px-5 py-2.5 text-sm font-bold text-white disabled:opacity-60">{loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Search"}</button>
      </form>
      <div className="space-y-2">
        {results.map((c) => (
          <div key={c.id} data-testid={`gdpr-${c.id}`} className="flex items-center gap-3 rounded-xl border border-border bg-card p-4">
            <div className="min-w-0 flex-1"><p className="truncate font-bold text-midnight">{c.name}</p><p className="truncate text-xs text-muted-foreground">{c.phone || c.email || c.matched_vrm || ""}</p></div>
            <button onClick={() => exportData(c.id, c.name)} data-testid={`gdpr-export-${c.id}`} className="inline-flex items-center gap-1 rounded-lg border border-border px-3 py-2 text-xs font-bold text-midnight hover:bg-secondary"><Download className="h-4 w-4" />Export</button>
            <button onClick={() => deleteData(c.id)} data-testid={`gdpr-delete-${c.id}`} className="inline-flex items-center gap-1 rounded-lg border border-danger/30 bg-danger-bg px-3 py-2 text-xs font-bold text-danger"><Trash2 className="h-4 w-4" />Delete</button>
          </div>
        ))}
        {results.length === 0 && q && !loading && <p className="rounded-lg border border-dashed border-border p-6 text-center text-sm text-muted-foreground">No matches.</p>}
      </div>
    </div>
  );
}
